import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  flex-grow: 1;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 12px;\n  font-weight: 300;\n  left: 0;\n  margin-bottom: 0;\n  margin-top: -27px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  &::before {\n    content: '/';\n    vertical-align: -50%;\n  }\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  color: ", ";\n  margin-bottom: 8px;\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { Col, Row } from 'react-styled-flexboxgrid';
import { compose, defaultProps, withPropsOnChange } from 'recompose';
import { SelectInput } from '../../Form/SelectInput';
import { theme } from '../../theme';
import styled from '../../utils/styling/styled-components';
import { getDaysInMonth, getFirstValidValue, getOptionRange } from './utils';

var disabledStyle = function disabledStyle(props) {
  return props['data-disabled'] && "\n  cursor: default;\n  opacity: 0.3;\n";
};

var Container = styled.div(_templateObject());
var Label = styled.label(_templateObject2(), theme.colors.slate, disabledStyle);
var Separator = styled.div(_templateObject3(), disabledStyle);
var ErrorLabel = styled(Label)(_templateObject4(), theme.colors.red); // @ts-ignore

var ColFlex = styled(Col)(_templateObject5());
var enhance = compose(defaultProps({
  name: 'date',
  placeholder: {
    day: 'dd',
    month: 'mm',
    year: 'yyyy'
  },
  options: {
    day: getOptionRange(1, 31),
    month: getOptionRange(1, 12),
    year: getOptionRange(1900, new Date().getFullYear())
  },
  value: {
    day: '',
    month: '',
    year: ''
  },
  error: {
    day: '',
    month: '',
    year: ''
  },
  errorText: {
    day: 'Please enter a valid day',
    month: 'Please enter a valid month',
    year: 'Please enter a valid year'
  }
}), withPropsOnChange(['value', 'error'], function (props) {
  var month = props.value.month ? parseInt(props.value.month) : 1;
  var year = props.value.year ? parseInt(props.value.year) : new Date().getFullYear();
  var dayOptions = props.options.day;
  var daysInMonth = getDaysInMonth(month, year);

  if (props.value.month) {
    dayOptions = getOptionRange(1, daysInMonth);
  }

  if (_typeof(props.errorText) === 'object') {
    if (parseInt(props.value.day) > daysInMonth) {
      props.onError("".concat(props.name, ".day"), props.errorText.day);
    }
  }

  var fieldErrors = _typeof(props.error) === 'object' ? props.error : {
    day: true,
    month: true,
    year: true
  };
  return {
    options: _objectSpread(_objectSpread({}, props.options), {}, {
      day: dayOptions
    }),
    fieldErrors: fieldErrors,
    errorLabel: _typeof(props.error) === 'object' ? props.errorText[getFirstValidValue(props.error)] : props.errorText
  };
}));
var DateInput = enhance(function (props) {
  return /*#__PURE__*/React.createElement(Container, {
    className: props.className
  }, /*#__PURE__*/React.createElement(Label, {
    "data-disabled": props.disabled
  }, props.label), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 4
  }, /*#__PURE__*/React.createElement(SelectInput, {
    label: "Month",
    hasHiddenLabel: true,
    disabled: props.loading || props.disabled,
    error: !!props.fieldErrors.month,
    id: "".concat(props.name, ".month"),
    name: "".concat(props.name, ".month"),
    placeholder: props.placeholder.month,
    onChange: props.onChange,
    options: props.options.month,
    position: props.position,
    value: props.value.month,
    useNative: props.useNative
  })), /*#__PURE__*/React.createElement(Separator, {
    "data-disabled": props.disabled
  }), /*#__PURE__*/React.createElement(Col, {
    xs: 4
  }, /*#__PURE__*/React.createElement(SelectInput, {
    label: "Day",
    hasHiddenLabel: true,
    disabled: props.loading || props.disabled,
    error: !!props.fieldErrors.day,
    id: "".concat(props.name, ".day"),
    name: "".concat(props.name, ".day"),
    placeholder: props.placeholder.day,
    onChange: props.onChange,
    options: props.options.day,
    position: props.position,
    value: props.value.day,
    useNative: props.useNative
  })), /*#__PURE__*/React.createElement(Separator, {
    "data-disabled": props.disabled
  }), /*#__PURE__*/React.createElement(ColFlex, null, /*#__PURE__*/React.createElement(SelectInput, {
    label: "Year",
    hasHiddenLabel: true,
    disabled: props.loading || props.disabled,
    error: !!props.fieldErrors.year,
    id: "".concat(props.name, ".year"),
    name: "".concat(props.name, ".year"),
    placeholder: props.placeholder.year,
    onChange: props.onChange,
    options: props.options.year,
    position: props.position,
    value: props.value.year,
    useNative: props.useNative
  }))), props.errorLabel && /*#__PURE__*/React.createElement(ErrorLabel, null, props.errorLabel));
});
export { DateInput };